import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header/Header';
import FeaturedHero from './components/FeaturedHero/FeaturedHero';
import BlogFeed from './components/BlogFeed/BlogFeed';
import BlogDetail from './components/BlogDetail/BlogDetail';
import ComingSoon from './components/ComingSoon/ComingSoon';
import Footer from './components/Footer/Footer';
import PageTransition from './components/PageTransition/PageTransition';
import { mockPosts, mockCategories, mockTags } from './data/mockData';
import './App.css';

// Home/Blog Feed Page Component
const BlogHomePage: React.FC = () => {
  // Get the featured post (first post in the array which is marked as featured)
  const featuredPost = mockPosts.find(post => post.isFeatured) || mockPosts[0];
  
  // Get non-featured posts for the blog grid
  const blogPosts = mockPosts.filter(post => !post.isFeatured);

  return (
    <>
      <FeaturedHero post={featuredPost} />
      <BlogFeed
        posts={blogPosts}
        categories={mockCategories}
        tags={mockTags}
        isLoading={false}
        error={null}
        itemsPerPage={6}
      />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        
        <main>
          <PageTransition>
            <Routes>
              {/* Blog home page */}
              <Route path="/" element={<BlogHomePage />} />
              <Route path="/blog" element={<BlogHomePage />} />
              
              {/* Individual blog post */}
              <Route path="/blog/:slug" element={<BlogDetail posts={mockPosts} />} />
              
              {/* Coming Soon Pages */}
              <Route path="/acerca-de" element={<ComingSoon pageTitle="Acerca de" />} />
              <Route path="/menu" element={<ComingSoon pageTitle="Menú" />} />
              <Route path="/contacto" element={<ComingSoon pageTitle="Contacto" />} />
              
              {/* Redirect any unknown routes to blog home */}
              <Route path="*" element={<Navigate to="/blog" replace />} />
            </Routes>
          </PageTransition>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
